// Takes Dismissal data from server and stores it in object with helper methods for accessing it.

import FrontEndModel from './FrontEndModel';

class Dismissal extends FrontEndModel {}

export default Dismissal;
